import { render, staticRenderFns } from "./BpcFormCreateBooking.vue?vue&type=template&id=5f784e63&"
import script from "./BpcFormCreateBooking.vue?vue&type=script&lang=js&"
export * from "./BpcFormCreateBooking.vue?vue&type=script&lang=js&"
import style0 from "./BpcFormCreateBooking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports